module.exports = __webpack_public_path__ + "img/Muerte a Terceros.d4ef29ec.svg";